import type { FC, HTMLAttributes, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface MainContainerProps extends HTMLAttributes<HTMLElement> {
    children: ReactNode
    as?: 'div' | 'section' | 'header' | 'footer' | 'article' | 'nav' | 'aside'
}

/** The 1440px page container with responsive side gutters. */
const MainContainer: FC<MainContainerProps> = ({ children, className, as: Tag = 'div', ...rest }): ReactNode => {
    return (
        <Tag
            {...rest}
            className={cn('mx-auto w-full max-w-site px-5 sm:px-8 lg:px-12', className)}
        >
            {children}
        </Tag>
    )
}

export default MainContainer
